















import mixin from './cardmixin.vue'
import Vue from 'vue'
export default Vue.extend({
  name: 'disabled-card',
  mixins: [mixin],
  data() {
    return {}
  },
  props: {
    id: {
      type: String,
      default: ''
    },
    index: {
      // 序号
      type: Number,
      default: null
    }
  },
})
